import React, { useCallback, useState } from 'react'
import PayPal from '../PaymentMethods/PayPal'
import CreditCard from '../PaymentMethods/CreditCard'
import {Form, Modal, ModalBody, ModalHeader} from "reactstrap";
import { CheckBox } from 'react-admin-base-bootstrap';
import { useAuth, useRefresh, ValidatorProvider } from 'react-admin-base';
import { useOnSuccess } from '../useOnSuccess';

const paymentMethods = {
  1: {
    name: 'Credit Card',
    component: CreditCard
  },
  2: {
    name: 'PayPal',
    component: PayPal
  }
};

export default function PayNow({ onSubmit }) {
  const [ paymentMethodId, setPaymentMethodId ] = useState(1);

  const Component = paymentMethods[paymentMethodId].component;

  const _onSubmit = useCallback(function(data) {
    return onSubmit({
      payment_method: paymentMethodId,
      ...(data || {})
    });
  }, [ paymentMethodId, onSubmit ]);
  
  return <div>
          <h5>Payment method</h5>
  
          <div className="my-4">
            {
              Object.entries(paymentMethods)
                .map(([id, obj]) => {
                  return <CheckBox
                    type="radio"
                    id={"pay_" + id}
                    checked={+paymentMethodId === +id}
                    onChange={() => setPaymentMethodId(+id)}
                    label={obj.name}
                  />;
                })
            }
          </div>
  
          <Component
            onSubmit={_onSubmit}
          />
  </div>;
}

export function PaymentModal({amount, onClose}) {
  const [ api ] = useAuth();
  const update = useRefresh();
  
  const [ onSubmit ] = useOnSuccess(
    useCallback(async function(paymentInfo) {
      await api.tokenized.post("/payment/test", paymentInfo);
      
      update && await update();
      onClose();
    }, [ api, onClose, update ]),
    'Payment verified. Thank you.'
  );
  
  return <Modal isOpen toggle={onClose}>
    <ModalHeader toggle={onClose}>
      Payment Test
    </ModalHeader>
    <ModalBody>
      <ValidatorProvider>
        <Form>
          <p><b>Payment Price:</b> ${amount}</p>
          <PayNow onSubmit={onSubmit} />
        </Form>
      </ValidatorProvider>
    </ModalBody>
  </Modal>
}
